import React, { useEffect, useState } from "react";
import Pagetitle from "../elements/Pagetitle";
import Timeline from "../elements/Timeline";
import axios from "axios";
import { getStrapiURL } from "../../lib/api";

const educationData = [
  {
    id: 1,
    title: "DESS in Data Science and AI",
    years: "2024 - 2025",
    content:
      "Advanced graduate program specializing in machine learning, artificial intelligence, and big data analytics. Core curriculum includes statistical modeling, deep learning architectures, natural language processing, computer vision, and predictive analytics. Hands-on projects with Python, R, TensorFlow, and PyTorch. Emphasis on ethical AI implementation, data privacy, and real-world applications in business intelligence and automated decision systems.",
    icon: "icon-graduation",
  },
  {
    id: 2,
    title: "Bachelor's Degree in Software Engineering",
    years: "2015 - 2018",
    content:
      "Comprehensive education in software development, database design, algorithms, and system architecture. Graduated with honors focusing on full-stack development and agile methodologies.",
    icon: "icon-graduation",
  },
  {
    id: 3,
    title: "Professional Certifications & Training",
    years: "2018 - Present",
    content:
      "AWS Certified Solutions Architect • React Native Specialist • Agile Scrum Master • Advanced TypeScript & Node.js • Cloud Infrastructure & DevOps • Kubernetes Administrator",
    icon: "icon-badge",
  },
  {
    id: 4,
    title: "Continuous Learning & Innovation",
    years: "Ongoing",
    content:
      "Staying current with emerging technologies through courses, workshops, and hands-on projects. Focus areas: AI/ML integration, Microservices, Serverless Architecture, Web3, and Advanced System Design.",
    icon: "icon-bulb",
  },
];

const experienceData = [
  {
    id: 1,
    title: "Senior Full-Stack Engineer & Technical Lead",
    years: "2020 - Present",
    content:
      "Leading development teams in building enterprise-grade applications. Tech Stack: React, Next.js, TypeScript, Node.js, PostgreSQL, MongoDB, AWS, Docker, Kubernetes. Implemented CI/CD pipelines, microservices architecture, and improved system performance by 60%. Mentoring junior developers and conducting code reviews.",
    icon: "icon-briefcase",
  },
  {
    id: 2,
    title: "Assistant Teacher in Software Engineering Tools",
    years: "2025 - present",
    content:
      "Teaching assistant at Université du Québec en Outaouais (UQO) supporting software engineering courses. Guided students in practical application of development tools, version control systems, and software development methodologies. Conducted lab sessions, graded assignments, and provided one-on-one mentoring for programming projects and debugging techniques.",
    icon: "icon-graduation",
  },
  {
    id: 3,
    title: "Full-Stack Mobile & Web Developer",
    years: "2018 - 2020",
    content:
      "Developed 20+ cross-platform mobile apps with React Native and responsive web applications with React. Specialized in e-commerce, fintech, and SaaS solutions. Technologies: React Native, Redux, GraphQL, RESTful APIs, Firebase. Delivered projects from concept to App Store/Play Store deployment.",
    icon: "icon-layers",
  },
  {
    id: 4,
    title: "Backend Developer & API Architect",
    years: "2017 - 2018",
    content:
      "Built scalable RESTful APIs and microservices using Node.js, Express, Spring Boot (Java), and Python Flask. Designed database schemas (PostgreSQL, MongoDB, Redis), implemented JWT authentication, OAuth, and optimized query performance for high-traffic applications handling 100K+ daily requests.",
    icon: "icon-energy",
  },
];

function Experiences() {


  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [experiences, setExperiences] = useState(null);
  const [educations, setEducations] = useState(null);
  
  // useEffect(() => {
  //   const fetchExpData = async () => {
  //     setLoading(true);
  //     try {
  //       let url = getStrapiURL("/api/experiences?populate=*");
  //       const res = await axios.get(url);
  //       console.log("data fetched exp", res.data.data[0].attributes.experience);
  //       setExperiences(res.data.data[0].attributes.experience);
  //       setLoading(false);
  //     } catch (error) {
  //       setError(error);
  //       setLoading(false);
  //     }
  //   };
  //   const fetchEduData = async () => {
  //     setLoading(true);
  //     try {
  //       let url = getStrapiURL("/api/educations");
  //       const res = await axios.get(url);
  //       console.log("data fetched edu", res.data.data);
  //       setEducations(res.data.data);
  //       setLoading(false);
  //     } catch (error) {
  //       setError(error);
  //       setLoading(false);
  //     }
  //   };
  //   fetchExpData();
  //   fetchEduData();
  // }, []);

  return (
    <section id="experiences">
      <div className="container">
        <Pagetitle title="Experience & Education" />
        <div className="experience-intro text-center mb-5">
          <h3 className="section-subtitle">Professional Journey & Growth</h3>
          <p className="section-description">
            8+ years of hands-on experience delivering impactful solutions across diverse industries
          </p>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="timeline edu bg-white rounded shadow-dark padding-30 overflow-hidden">
              <div className="timeline-header mb-4">
                <i className="icon-graduation timeline-header-icon"></i>
                <h4 className="timeline-title">Education & Certifications</h4>
                <p className="timeline-subtitle">Building a strong foundation</p>
              </div>
              {educationData?.map((education) => (
                <Timeline key={education?.id} education={education} />
              ))}
              <span className="line"></span>
            </div>
          </div>

          <div className="col-md-6">
            <div className="spacer d-md-none d-lg-none" data-height="30"></div>
            <div className="timeline exp bg-white rounded shadow-dark padding-30 overflow-hidden">
              <div className="timeline-header mb-4">
                <i className="icon-briefcase timeline-header-icon"></i>
                <h4 className="timeline-title">Professional Experience</h4>
                <p className="timeline-subtitle">Delivering real-world impact</p>
              </div>
              {experienceData?.map((experience) => (
                <Timeline key={experience.id} education={experience} />
              ))}
              <span className="line"></span>
            </div>
          </div>
        </div>
        <div className="experience-stats mt-5">
          <div className="row text-center">
            <div className="col-md-3 col-6 mb-3">
              <div className="stat-card">
                <i className="icon-rocket"></i>
                <h3 className="stat-number">50+</h3>
                <p className="stat-label">Projects Shipped</p>
              </div>
            </div>
            <div className="col-md-3 col-6 mb-3">
              <div className="stat-card">
                <i className="icon-users"></i>
                <h3 className="stat-number">15+</h3>
                <p className="stat-label">Teams Led</p>
              </div>
            </div>
            <div className="col-md-3 col-6 mb-3">
              <div className="stat-card">
                <i className="icon-globe"></i>
                <h3 className="stat-number">10+</h3>
                <p className="stat-label">Industries Served</p>
              </div>
            </div>
            <div className="col-md-3 col-6 mb-3">
              <div className="stat-card">
                <i className="icon-trophy"></i>
                <h3 className="stat-number">98%</h3>
                <p className="stat-label">Client Satisfaction</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Experiences;
